import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Col, Row} from 'antd';

import DocumentHead from '../../../elements/components/DocumentHead';
import scrollToTop from '../../../elements/lib/scrollToTop';
import Logger from '../../../../../lib/Logger';

class InterviewScreen extends Component {

  render() {
    return (
      <Translation>{(t) => 
        <>

          <DocumentHead title={t('content_route_interview')} />

          <Row>
            <Col span={24}>

              <iframe src="https://www.cognitoforms.com/f/RnQXxvDs4Uyff6Y8NCacyg?id=29" frameborder="0" scrolling="yes" seamless="seamless" height="800" width="100%" title="Interview"></iframe>

            </Col>
          </Row>

        </>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    scrollToTop();

    const script = document.createElement("script");
    script.src = "https://www.cognitoforms.com/scripts/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }
}

export default InterviewScreen;

Logger.log('silly', `InterviewScreen loaded.`);
